/*  MUI  */
import { Box, Link as ExternalLink, Typography } from '@mui/material';

/*  React  */
import React from 'react';
import { withTranslation } from 'react-i18next';

const ImportantResources = ({ t }) => (
    <Box width="100%" data-testid="importantResources">
        <Typography variant="h4" mb="16px">
            {t('Integrations.importantResources.title')}
        </Typography>
        <ul>
            <li className="li-with-spacing">
                <ExternalLink
                    className="link--secondary"
                    data-testid="importantResourcesLink1"
                    href="https://support.auvik.com/hc/en-us/articles/10857322651668-Auvik-SaaS-Management-Saaslio-Deployment-Security-Considerations"
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                >
                    <Typography display="inline">
                        {t(
                            'Integrations.importantResources.securityConsiderations'
                        )}
                    </Typography>
                </ExternalLink>
            </li>
            <li className="li-with-spacing">
                <ExternalLink
                    className="link--secondary"
                    data-testid="importantResourcesLink2"
                    href="https://support.auvik.com/hc/en-us/sections/11423558673172"
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                >
                    <Typography display="inline">
                        {t(
                            'Integrations.importantResources.fullDeploymentGuide'
                        )}
                    </Typography>
                </ExternalLink>
            </li>
        </ul>
    </Box>
);

export default withTranslation()(ImportantResources);
